module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "Please select"
    },
    model: {
      value: (_vm.selectedRange),
      callback: function($$v) {
        _vm.selectedRange = $$v
      },
      expression: "selectedRange"
    }
  }, _vm._l((Object.keys(_vm.timeRanges)), function(key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": key,
        "value": key
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf62127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/search/TimeRangeSelect.vue
// module id = 3197
// module chunks = 3